import React from "react";
import { useNavigate } from "react-router-dom";

import {
  TABLE_DATA,
  TABLE_HEADERS,
  keyMapping,
  topDataList,
} from "../../../../constants/SalesDeliveryOrderList";

import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";

const DeliveryOrderList = () => {
  const navigate = useNavigate();

  const handleDeliveryOrderDetails = () => {
    navigate(ROUTES_NAVIGATION.VIEWDELIVERYDETAILS)
  }

  return (
    <ListPage
      isButtonRequired={false}
      headerTopText="Sales / Delivery Order"
      headerTitle="Stock Allotments"
      listTitle="All Stocks"
      topDetailsList={topDataList}
      tableData={TABLE_DATA}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleViewButton={handleDeliveryOrderDetails}
    />
  );
};

export default DeliveryOrderList;
